import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea } from 'semantic-ui-react'

import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLAdmin, WindowLocationAdmin} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function AccountComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
			DeleteRecord(data.id);
		}
	}
	function DeleteConfirmation(id){
		setAlertcontent({intent:'delete',settings:{id:id,centered:false,icon:'warning',title:'Delete Confirmation!',html:'This process is not ireversible. Once you continue the process, the record will be deleted forever.',footer:'none'}});
		setalert(true);
	}


	/* ------------------------------------------
		List with paginations
	---------------------------------------------*/
	const [search, setsearch]  = useState({
			email:'',
			username:'',
			first_name:'',
			last_name:''
	});

	const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

			 setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
			 setalert(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/account/http.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
						setalert(false);

				})
				.catch(function (error){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
					setalert(false);
				});
		}

		function handleSubmitForm(values, props){
			TableList(pagenumber,values);
	  }

	 /* ------------------------------------------
			List with paginations end
		---------------------------------------------*/


	/*-------------------------------------
	 Delete
	--------------------------------------*/
	function DeleteRecord(id){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Deleting',html:"Deleting record is on process, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','delete');
		formData.append('id',id);
		axios.post('/admin/account/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj=='success'){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Record successfully deleted."}});
					setalert(true);
					setTimeout(function() {
						WindowReload();
					},2000);
				}else{
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Delete Failed',html:"Record not successfully deleted."}});
					setalert(true);
					setTimeout(function() {setalert(false);},2000);
				}
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
}




	useEffect(()=>{
		TableList(pagenumber,search);
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form>
				 <Formik
					initialValues={search}
					onSubmit={handleSubmitForm}
					render={formProps => {
					const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
						return(
			         <div className="panel hasbottom">
			            <div className="panel-body">

									<Form.Group widths="equal">
										<Field name="username">
												{({ field, form }) => (
												<Form.Field>
													<label>Account Code</label>
													<Input fluid {...field} onChange={handleChange}/>
												</Form.Field>
												)}
										</Field>
										<Field name="email">
												{({ field, form }) => (
												<Form.Field>
													<label>Email</label>
													<Input fluid {...field} onChange={handleChange}/>
												</Form.Field>
												)}
										</Field>
										<Field name="first_name">
												{({ field, form }) => (
												<Form.Field>
													<label>First Name</label>
													<Input fluid {...field} onChange={handleChange}/>
												</Form.Field>
												)}
										</Field>
										<Field name="last_name">
												{({ field, form }) => (
												<Form.Field>
													<label>Last Name</label>
													<Input fluid {...field} onChange={handleChange}/>
												</Form.Field>
												)}
										</Field>
									</Form.Group>

									</div>{/*.panel-body*/}
			            <div className="panel-footer">
										<Button className='basic' size='large' icon='refresh' content='Reset' onClick={()=>WindowReload()}/>
										<Button className='secondary' size='large' icon='search' content='Search' onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>

					<div className="panel">
						 <div className="panel-header">Account List</div>
						 <div className="panel-body">
						 	 <div className="table-responsive">
								 <Table celled>
									 <Table.Header>
										 <Table.Row>
											 <Table.HeaderCell>Account Code</Table.HeaderCell>
											 <Table.HeaderCell>Account Name</Table.HeaderCell>
											 <Table.HeaderCell>Country</Table.HeaderCell>
											 <Table.HeaderCell>Phone Number</Table.HeaderCell>
											 <Table.HeaderCell>Email</Table.HeaderCell>
											 <Table.HeaderCell>Status</Table.HeaderCell>
											 <Table.HeaderCell>Trade Account</Table.HeaderCell>
											 <Table.HeaderCell>Documents</Table.HeaderCell>
											 <Table.HeaderCell>Delete</Table.HeaderCell>
											 <Table.HeaderCell>Edit</Table.HeaderCell>
										 </Table.Row>
									 </Table.Header>

									 <Table.Body>
												 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='10' textAlign="center">No record found</Table.Cell></Table.Row>}
												 {list.map(function(data, key){
													 return <Table.Row key={key} className={data.status=='3'?'negative':''}>
															 <Table.Cell>{data.username}</Table.Cell>
															 <Table.Cell>{data.account_name}</Table.Cell>
															 <Table.Cell>{data.country}</Table.Cell>
															 <Table.Cell>{data.primary_number}</Table.Cell>
															 <Table.Cell>{data.email}</Table.Cell>
															 <Table.Cell collapsing>{renderHTML(data.status_text)}</Table.Cell>
															 <Table.Cell collapsing>
															    {data.status==1&&<Button className='green' icon='check circle outline' size='mini' content='For Approval' as="a" href={WindowURLAdmin('/account/approval/'+data.id)}/>}
																	{data.status==2&&<div className="badgecircle-success green"><i className="checkmark icon"></i>Approved</div>}
																	{data.status==3&&<div className="badgecircle-danger red"><i className="close icon"></i>Rejected</div>}
															 </Table.Cell>
															 <Table.Cell collapsing>{renderHTML(data.filetype)}</Table.Cell>
															 <Table.Cell collapsing>
																 <Button className='red' size='mini'  icon='trash alternate outline' onClick={()=>DeleteConfirmation(data.id)} />
															 </Table.Cell>
															 <Table.Cell collapsing>
																 <Button className='primary' size='mini' icon='edit' as="a" href={WindowURLAdmin('/account/edit/'+data.id)}/>
															 </Table.Cell>
													 </Table.Row>
												 })}
										 </Table.Body>
										 {list.length>0&&
											 <Table.Footer fullWidth>
													 <Table.Row>
													 <Table.HeaderCell colSpan='10'>
															 <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
													 </Table.HeaderCell>
													 </Table.Row>
											 </Table.Footer>
										 }
								 </Table>
								 </div>
						 </div>
					</div>

      </div>
    </React.Fragment>
  )
}
